var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import * as moment from "moment";
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Card.prototype, "localStart", {
        get: function () { return (this.start && moment.isMoment(this.start)) ? this.start : parseDate(this.start); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Card.prototype, "now", {
        get: function () { return moment(moment.now()); },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: String })
    ], Card.prototype, "registerUrl", void 0);
    __decorate([
        Prop({ type: String })
    ], Card.prototype, "registrationUrl", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Card.prototype, "registered", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Card.prototype, "full", void 0);
    __decorate([
        Prop({ type: [moment, String] })
    ], Card.prototype, "start", void 0);
    __decorate([
        Prop({ type: String, default: "MMMM D, YYYY" })
    ], Card.prototype, "dateFormat", void 0);
    Card = __decorate([
        Component({
            name: "Card",
            components: {}
        })
    ], Card);
    return Card;
}(Vue));
export default Card;
;
function parseDate(value) {
    return value
        ? moment(value)
        : undefined;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/Register.vue
// module id = 60
// module chunks = 0 1 2 5 13 14 15 16